import Medusa from "@medusajs/js-sdk";

const conf = {
  baseUrl: process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL as string,
  debug: process.env.NODE_ENV === "development",
  publishableKey: process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY,
};

if (!conf.baseUrl?.trim() || !conf.publishableKey?.trim()) {
  const missing = [
    !conf.baseUrl?.trim() && "NEXT_PUBLIC_MEDUSA_BACKEND_URL",
    !conf.publishableKey?.trim() && "NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY",
  ].filter(Boolean);

  throw new Error(
    `[Medusa SDK] Faltan variables de entorno críticas:\n` +
      missing.map((v) => `- ${v}`).join("\n")
  );
}

export const sdk = new Medusa(conf);
